import { forwardRef } from "react";
import cn from "clsx";
import { useMainMenuContext } from "../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
var NavbarIconButton = function NavbarIconButton(_ref, ref) {
  var _Icon;
  var className = _ref.className,
    Icon = _ref.Icon,
    href = _ref.href,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Button' : _ref$label,
    onClick = _ref.onClick;
  var _useMainMenuContext = useMainMenuContext(),
    theme = _useMainMenuContext.theme;
  var buttonClassNames = cn('w-32 h-32 flex items-center justify-center flex-shrink-0', theme.nav.iconColorClassName, className);
  var renderIcon = function renderIcon() {
    return _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
      size: 24,
      "aria-hidden": true,
      ignoreColor: true,
      className: "fill-current"
    }));
  };
  if (href) {
    return /*#__PURE__*/_jsx("a", {
      href: href,
      onClick: onClick,
      "aria-label": label,
      className: buttonClassNames,
      ref: ref,
      children: renderIcon()
    });
  }
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    onClick: onClick,
    "aria-label": label,
    className: buttonClassNames,
    ref: ref,
    children: renderIcon()
  });
};
export default /*#__PURE__*/forwardRef(NavbarIconButton);